/*
 * Public API Surface of ngx-messaging
 */
//  chat module
export * from './modules/chat/chat.module';

// chat module components

export * from './modules/chat/external-components/ngx-messaging-layout/ngx-messaging-layout.component';
export * from './modules/chat/external-components/ngx-messaging-channel/ngx-messaging-channel.component';
export * from './modules/chat/external-components/ngx-messaging-chat/ngx-messaging-chat.component';
export * from './modules/chat/external-components/ngx-messaging-away/ngx-messaging-away.component';
export * from './modules/chat/components/call-recive/call-recive.component';
export * from './modules/chat/components/channels/channels.component';
export * from './modules/chat/components/channel/channel.component';
export * from './modules/chat/components/layout/layout.component';
export * from './modules/chat/components/channels-list-filters/channels-list-filters.component';
export * from './modules/chat/components/channels-list/channels-list.component';
export * from './modules/chat/components/channels-list-item/channels-list-item.component';
export * from './modules/chat/components/channels-list-search/channels-list-search.component';
export * from './modules/chat/components/channel-body/channel-body.component';
export * from './modules/chat/components/channel-header/channel-header.component';
export * from './modules/chat/components/channel-info/channel-info.component';
export * from './modules/chat/components/channel-input/channel-input.component';
export * from './modules/chat/components/emoji/emoji.component';
export * from './modules/chat/components/generic-sprinner/generic-spinner.component';
export * from './modules/chat/components/giphy/giphy.component';
export * from './modules/chat/components/join-channel/join-channel.component';
export * from './modules/chat/components/list-members-channel-to-call/list-members-channel-to-call.component';
export * from './modules/chat/components/media-upload/media-upload.component';
export * from './modules/chat/components/members/members.component';
export * from './modules/chat/components/message/message.component';
export * from './modules/chat/components/new-chat-dialog/new-broadcast-channel/new-broadcast-channel.component';
export * from './modules/chat/components/new-chat-dialog/new-direct-chat/new-direct-chat.component';
export * from './modules/chat/components/new-chat-dialog/new-group-chat/new-group-chat.component';
export * from './modules/chat/components/new-chat-dialog/new-phone-chat/new-phone-chat.component';
export * from './modules/chat/components/open-modal/open-modal.component';
export * from './modules/chat/components/profile-actions/profile-actions.component';
export * from './modules/chat/components/repair-order/repair-order.component';
export * from './modules/chat/components/select-users/select-users.component';
export * from './modules/chat/components/smart-replies/smart-replies.component';
export * from './modules/chat/components/text-processor/text-processor.component';
export * from './modules/chat/components/video/video.component';
export * from './modules/chat/components/video-conference/video-conference.component';
export * from './modules/chat/components/workspace-drawer/workspace-drawer.component';
export * from './modules/chat/components/users-search/users-search.component';
export * from './modules/chat/components/users-selected/users-selected.component';
export * from './modules/chat/components/tags/tags.component';
export * from './modules/chat/components/text-spinner/text-spinner.component';
export * from './modules/chat/components/manual-status/manual-status.component';
export * from './modules/chat/components/channels-list-filters/selector-filter/selector-filter.component';
export * from './modules/chat/components/channels-list-filters/check-filter/check-filter.component';
export * from './modules/chat/components/channel-blank/channel-blank.component';
export * from './modules/chat/components/channel-skeletons/channel-skeletons.component';
export * from './modules/chat/components/standards-responses/standard-responses.component';
export * from './modules/chat/components/manual-status/manual-status.component';
export * from './modules/chat/components/channels-list-filters/selector-filter/selector-filter.component';
export * from './modules/chat/components/attachments/attachments.component';
export * from './modules/chat/components/old-messages-banner/old-messages-banner.component';
export * from './modules/chat/components/channel-status/channel-status.component';
export * from './modules/chat/components/channel-edit-form/channel-edit-form.component';
export * from './modules/chat/components/last-messages-banner/last-messages-banner.component';
export * from './modules/chat/components/phone-edit-form/phone-edit-form.component';
export * from './modules/chat/components/owner-change/owner-change.component';
export * from './modules/chat/components/languaje-selector/language-selector.component';

//  chat module pipes
export * from './modules/chat/pipes/pipes.module';
export * from './modules/chat/pipes/hyperlink.pipe';
export * from './modules/chat/pipes/long-text.pipe';
export * from './modules/chat/pipes/phonePipeLib.pipe';
export * from './modules/chat/pipes/plainText.pipe';
export * from './modules/chat/pipes/sanitizeHtml.pipe';
export * from './modules/chat/pipes/sort.pipe';
export * from './modules/chat/pipes/shortName.pipe';
export * from './modules/chat/pipes/emojis.pipe';
export * from './modules/chat/pipes/alternate-translations.pipe';
export * from './modules/chat/pipes/author-color.pipe';
export * from './modules/chat/pipes/date-custom.pipe';

//  chat module directives

export * from './modules/shared/directives/directives.module';
export * from './modules/shared/directives/has-dealer-settings.directive';
export * from './modules/shared/directives/has-permissions.directive';
export * from './modules/shared/directives/has-workspce-feature.directive';
export * from './modules/shared/directives/has-channel-feature.directive';
export * from './modules/shared/directives/mat-auto-complete-scroll.directive';

// chat module store
export * from './modules/chat/store/chat.actions';
export * from './modules/chat/store/chat.reducer';
export * from './modules/chat/store/channels.effects';
export * from './modules/chat/store/messages.effects';
export * from './modules/chat/store/notifications.effects';

//  chat module services

export * from './modules/chat/services/websocket.service';
export * from './modules/chat/services/denoise.service';
export * from './modules/chat/services/encrypt.service';
export * from './modules/chat/services/giphy.service';
export * from './modules/chat/services/logs.service';
export * from './modules/chat/services/permissions.service';
export * from './modules/chat/services/sounds.service';
export * from './modules/chat/services/text-processor.service';
export * from './modules/chat/services/translater.service';
export * from './modules/chat/services/contact-directory/contact-directory-api.service';
export * from './modules/chat/services/messaging-api/messaging-api.service';
export * from './core/messaging-config';

// shared module
export * from './modules/shared/shared.module';

// shared module components
export * from './modules/shared/components/alert/alert.component';
export * from './modules/shared/components/dark-mode-toggle/dark-mode-toggle.component';
export * from './modules/shared/components/logout/logout.component';
export * from './modules/shared/components/profile/profile.component';
export * from './modules/shared/components/profile-modal/profile-modal.component';
export * from './modules/shared/components/sidebar/sidebar.component';
export * from './modules/shared/components/token-error/token-error.component';
export * from './modules/shared/components/photo-preview/photo-preview.component';
export * from './modules/shared/components/messaging-avatar/messaging-avatar.component';

// shared module store
export * from './modules/shared/store/ui.actions';
export * from './modules/shared/store/ui.reducer';

// user module
export * from './modules/user/user.module';

// user module store
export * from './modules/user/store/user.actions';
export * from './modules/user/store/user.effects';
export * from './modules/user/store/user.reducer';

// user module services
export * from './modules/user/services/auth.interceptor';
export * from './modules/user/services/authentication.service';

// material module
export * from './modules/material/material';

// corse services

export * from './core/services/aws.service';
export * from './core/services/dark-mode.service';
export * from './core/services/http.context';
export * from './core/services/jwt.service';
export * from './core/services/snackbar.service';
export * from './core/services/logger.service';

// interfaces

export * from './modules/chat/interfaces/EPermissions';
export * from './modules/chat/interfaces/IAttachment';
export * from './modules/chat/interfaces/generics';
export * from './modules/chat/interfaces/commons';
export * from './modules/chat/interfaces/IAttachment';
export * from './modules/chat/interfaces/IChannel';
export * from './modules/chat/interfaces/IMessageableEntity';
export * from './modules/chat/interfaces/IDealer';
export * from './modules/chat/interfaces/IDealerSettings';
export * from './modules/chat/interfaces/IGif';
export * from './modules/chat/interfaces/IMessage';
export * from './modules/chat/interfaces/INotification';
export * from './modules/chat/interfaces/IRepairOrder';
export * from './modules/chat/interfaces/IRole';
export * from './modules/chat/interfaces/IStandardResponse';
export * from './modules/chat/interfaces/ITag';
export * from './modules/chat/interfaces/IVideoCallMember';
export * from './modules/chat/interfaces/IVideoCallMember';
export * from './modules/chat/interfaces/IWorkspace';
export * from './modules/user/interfaces/IUserProfile';
export * from './core/interfaces/IMessagingEnvironment';
export * from './core/messaging-config';

// reducer principal
export * from './app.reducer';
